import * as React from "react";
import { makeStyles, mergeClasses } from "@fluentui/react-components";

export interface SectionProps {
  children: React.ReactNode;
  className?: string;
}

const useStyles = makeStyles({
  root: {
    marginBottom: "30px",
  },
});

const Section: React.FC<SectionProps> = ({ children, className }) => {
  const styles = useStyles();
  return <div className={mergeClasses(styles.root, className)}>{children}</div>;
};

export default Section;
